import { useEffect, useState } from "react";
import { getSubscription, getDevices, updateSubscription, createSubscription } from '../../utilities/orgPanelApiCalls';
import { deviceTypes } from '../../constants/deviceTypes.js';
import { errorToast, successToast } from '../../constants/toast';
import { steps, ChangeCountManagerModal } from './ChangeCountManagerModal.js'
import { setNewLicenseCount as setNewLicenseCountStore } from "../../utilities/appStore.js";
import { useStore } from "../../utilities/appStore.js";

export default function ChangeCountManagerModalViewModel({ isOpen, handleClose, handleSuccess, accountId }) {
    const orgId = useStore((state) => state.CurrentOrganizationId);
    const [currentStep, setCurrentStep] = useState(steps.ChangeCount);
    const [toast, SetToast] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [currentLicenseCount, setCurrentLicenseCount] = useState(0);
    const [newLicenseCount, setNewLicenseCount] = useState(0);
    const [subscriptionDevices, setSubscriptionDevices] = useState([]);
    const [subscriptionExists, setSubscriptionExists] = useState();

    const closeModel = () => {
        setCurrentStep(steps.ChangeCount);
        handleClose();
    }

    const makeToast = (message, type) => {
        SetToast({
            display: true,
            message: message,
            type: type
        });
    }

    const changeCount = async () => {
        if (subscriptionExists) {
            setCurrentStep(steps.Deactivate);
        }
        else {
            setIsLoading(true);

            const result = await createSubscription(accountId, newLicenseCount, `Organizations/${orgId}/Devices`);

            if (result.status > 299) {               
                makeToast(`Failed to create subscription - ${result.data.substring(0, 150)}`, errorToast);
                setIsLoading(false);
            }
            else {
                window.location.href = result.data;
            }
        }
    }

    const saveSubscription = async () => {
        setIsLoading(true);
        const result = await updateSubscription(accountId, newLicenseCount, subscriptionDevices);
        if (result.status > 299) {
            makeToast(`Failed to updated subscription - ${result.data.substring(0, 150)}`, errorToast);
            setIsLoading(false);
        }
        if (result.status <= 299) {
            makeToast("Subscription updated", successToast);
            setNewLicenseCountStore(newLicenseCount);
            setIsLoading(false);
            handleSuccess();
            closeModel();
        }
    }

    const devicesSet = () => {
        setCurrentStep(steps.Confirm);
    }

    const toastToggleCallback = () => {
        SetToast({
            display: false,
            message: ""
        });
    }

    useEffect(() => {
        async function load() {
            if (!isOpen)
                return;

            setIsLoading(true);
            //setErrorMessage(null);
            var subscriptionPromise = getSubscription(accountId);
            var devicePromise = getDevices(accountId);

            var subData = await subscriptionPromise;
            var deviceResult = await devicePromise;

            if (subData.status > 299) {
                console.log("Failed to load subscription!");
                setSubscriptionExists(false);
                setCurrentLicenseCount(0);
            }
            else {
                setSubscriptionExists(true);
                const newData = subData.data
                setCurrentLicenseCount(newData.seats)
                setCurrentStep(steps.ChangeCount);
                setNewLicenseCount(newData.seats);
            }

            if (deviceResult.status) {
                console.log("Failed to load device data");
            }
            
            const subscriptionDevicesList = deviceResult?.data?.filter(x => x.deviceType == deviceTypes.SubscriptionDevice);
            setSubscriptionDevices(subscriptionDevicesList);
            setIsLoading(false);
        }
        load();

    }, [accountId, isOpen]);

    return (
        <ChangeCountManagerModal
            isOpen={isOpen}
            isLoading={isLoading}
            currentStep={currentStep}
            closeModel={closeModel}
            changeCount={changeCount}
            newLicenseCount={newLicenseCount}
            setNewLicenseCount={setNewLicenseCount}
            devicesSet={devicesSet}
            saveSubscription={saveSubscription}
            currentLicenseCount={currentLicenseCount}
            setSubscriptionDevices={setSubscriptionDevices}
            subscriptionDevices={subscriptionDevices}
            toastToggleCallback={toastToggleCallback}
            toast={toast}
            subscriptionExists={subscriptionExists}
        />
    )
};